/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Fisify API
 * OpenAPI spec version: 1.0.0
 */

export type Capability = typeof Capability[keyof typeof Capability];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Capability = {
  ANKLE_EVERSION: 'ANKLE_EVERSION',
  ANKLE_INVERSION: 'ANKLE_INVERSION',
  CERVICAL_EXTENSION: 'CERVICAL_EXTENSION',
  CERVICAL_FLEXION: 'CERVICAL_FLEXION',
  CERVICAL_INCLINATION: 'CERVICAL_INCLINATION',
  CERVICAL_ROTATION: 'CERVICAL_ROTATION',
  CHEST_ROTATION: 'CHEST_ROTATION',
  DORSAL_EXTENSION: 'DORSAL_EXTENSION',
  DORSAL_FLEXION: 'DORSAL_FLEXION',
  DORSAL_INCLINATION: 'DORSAL_INCLINATION',
  DORSAL_ROTATION: 'DORSAL_ROTATION',
  DORSIFLEXION: 'DORSIFLEXION',
  ELBOW_EXTENSION: 'ELBOW_EXTENSION',
  ELBOW_FLEXION: 'ELBOW_FLEXION',
  ELBOW_PRONATION: 'ELBOW_PRONATION',
  ELBOW_SUPINATION: 'ELBOW_SUPINATION',
  FINGER_ABDUCTION: 'FINGER_ABDUCTION',
  FINGER_ADDUCTION: 'FINGER_ADDUCTION',
  FINGER_EXTENSION: 'FINGER_EXTENSION',
  FINGER_FLEXION: 'FINGER_FLEXION',
  FINGER_INTERPHALANGEAL_EXTENSION: 'FINGER_INTERPHALANGEAL_EXTENSION',
  FINGER_INTERPHALANGEAL_FLEXION: 'FINGER_INTERPHALANGEAL_FLEXION',
  HIP_ABDUCTION: 'HIP_ABDUCTION',
  HIP_ADDUCTION: 'HIP_ADDUCTION',
  HIP_EXTENSION: 'HIP_EXTENSION',
  HIP_EXTERNAL_ROTATION: 'HIP_EXTERNAL_ROTATION',
  HIP_FLEXION: 'HIP_FLEXION',
  HIP_INTERNAL_ROTATION: 'HIP_INTERNAL_ROTATION',
  KNEE_EXTENSION: 'KNEE_EXTENSION',
  KNEE_FLEXION: 'KNEE_FLEXION',
  LATERAL_SCAPULAR_ROTATION: 'LATERAL_SCAPULAR_ROTATION',
  LUMBAR_EXTENSION: 'LUMBAR_EXTENSION',
  LUMBAR_FLEXION: 'LUMBAR_FLEXION',
  LUMBAR_INCLINATION: 'LUMBAR_INCLINATION',
  LUMBAR_ROTATION: 'LUMBAR_ROTATION',
  MEDIAL_SCAPULAR_ROTATION: 'MEDIAL_SCAPULAR_ROTATION',
  '1_TOE_ABDUCTION': '1_TOE_ABDUCTION',
  '1_TOE_ADDUCTION': '1_TOE_ADDUCTION',
  '1_TOE_EXTENSION': '1_TOE_EXTENSION',
  '1_TOE_FLEXION': '1_TOE_FLEXION',
  PELVIC_ANTEVERSION: 'PELVIC_ANTEVERSION',
  PELVIC_RETROVERSION: 'PELVIC_RETROVERSION',
  PLANTAR_FLEXION: 'PLANTAR_FLEXION',
  RADIAL_DEVIATION: 'RADIAL_DEVIATION',
  SHOULDER_ABDUCTION: 'SHOULDER_ABDUCTION',
  SHOULDER_ADDUCTION: 'SHOULDER_ADDUCTION',
  SHOULDER_EXTENSION: 'SHOULDER_EXTENSION',
  SHOULDER_EXTERNAL_ROTATION: 'SHOULDER_EXTERNAL_ROTATION',
  SHOULDER_FLEXION: 'SHOULDER_FLEXION',
  SHOULDER_HORIZONTAL_ABDUCTION: 'SHOULDER_HORIZONTAL_ABDUCTION',
  SHOULDER_HORIZONTAL_ADDUCTION: 'SHOULDER_HORIZONTAL_ADDUCTION',
  SHOULDER_INTERNAL_ROTATION: 'SHOULDER_INTERNAL_ROTATION',
  THUMB_ABDUCTION: 'THUMB_ABDUCTION',
  THUMB_ADDUCTION: 'THUMB_ADDUCTION',
  THUMB_EXTENSION: 'THUMB_EXTENSION',
  THUMB_FLEXION: 'THUMB_FLEXION',
  THUMB_OPPOSITION: 'THUMB_OPPOSITION',
  TOES_ABDUCTION: 'TOES_ABDUCTION',
  TOES_ADDUCTION: 'TOES_ADDUCTION',
  TOES_EXTENSION: 'TOES_EXTENSION',
  TOES_FLEXION: 'TOES_FLEXION',
  ULNAR_DEVIATION: 'ULNAR_DEVIATION',
  WRIST_FLEXION: 'WRIST_FLEXION',
  WRIST_EXTENSION: 'WRIST_EXTENSION',
  SUPINE: 'SUPINE',
  SIT: 'SIT',
  STAND: 'STAND',
  KNIGHT: 'KNIGHT',
  QUADRUPED: 'QUADRUPED',
  PRONE: 'PRONE',
} as const;
